import styled from 'styled-components';

export const SkillRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const SkillList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
`;

export const FieldHint = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? 'rgba(230,231,238,0.7)'};
`;
